export const unitRegistry = [
  { unitId: 1, unit: "dm2" },
  { unitId: 2, unit: "m2" },
  { unitId: 3, unit: "kg" },
  { unitId: 4, unit: "m3" },
  { unitId: 5, unit: "m" },
  { unitId: 6, unit: "MJ" },
  { unitId: 7, unit: "kWh" },
  { unitId: 8, unit: "L" },
  { unitId: 9, unit: "g" },
  { unitId: 10, unit: "cm" },
  { unitId: 11, unit: "ml" },
  { unitId: 12, unit: "%" },
  { unitId: 13, unit: "unité" },
  { unitId: 14, unit: "kg eq. CO2" },
  { unitId: 15, unit: "kg eq. SO2" },
  { unitId: 16, unit: "kg eq. CFC" },
  { unitId: 17, unit: "kg eq. éthylène" },
  { unitId: 18, unit: "mg" },
  { unitId: 19, unit: "mm3" },
  { unitId: 20, unit: "g eq. SO2" },
  { unitId: 21, unit: "g eq. éthylène" },
  { unitId: 22, unit: "g/m2" },
  { unitId: 23, unit: "kg eq. Antimoine" },
  { unitId: 24, unit: "m3/UF" },
  { unitId: 25, unit: "kg/m2" },
  { unitId: 26, unit: "kWhep" },
  { unitId: 27, unit: "" },
  { unitId: 28, unit: "m³ d'air" },
  { unitId: 29, unit: "kg eq. C2H4" },
  { unitId: 30, unit: "kg eq. PO43-" },
  { unitId: 31, unit: "tonne" },
  { unitId: 32, unit: "m³ d'eau" },
  { unitId: 33, unit: "person réserve" },
  { unitId: 34, unit: "kg eq. Sb" },
  { unitId: 35, unit: "mole eq. H+" },
  { unitId: 36, unit: "mole eq. N" },
  { unitId: 37, unit: "km" },
  { unitId: 38, unit: "mL" },
  { unitId: 39, unit: "Mpa" },
  { unitId: 40, unit: "an" },
  { unitId: 41, unit: "kg/m3" },
  { unitId: 42, unit: "kWh/m3" },
  { unitId: 43, unit: "mm" },
  { unitId: 44, unit: "kg/mL" },
  { unitId: 45, unit: "ml/m2" },
  { unitId: 46, unit: "kWc" },
  { unitId: 47, unit: "m3/m2" },
  { unitId: 48, unit: "m/m2" },
  { unitId: 49, unit: "litres/m3" },
  { unitId: 50, unit: "mm x mm" },
  { unitId: 51, unit: "kg/2 ml" },
  { unitId: 52, unit: "kg/4 ml" },
  { unitId: 53, unit: "kW" },
  { unitId: 54, unit: "m2.K/W" },
  { unitId: 55, unit: "m3/h" },
  { unitId: 56, unit: "m²/ml" },
  { unitId: 62, unit: "kg/m" },
  { unitId: 63, unit: "kg de P.éq" },
  { unitId: 64, unit: "kg de N.éq" },
  { unitId: 65, unit: "kg de COVNM" },
  { unitId: 66, unit: "Incidence de maladies" },
  { unitId: 67, unit: "kBq de U235.éq" },
  { unitId: 68, unit: "CTUe" },
  { unitId: 69, unit: "CTUh" },
  { unitId: 70, unit: "m³.éq de priv. dans le" },
];
